/** @jsx jsx */
import React, { useContext } from 'react'
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import {
  getRiverUnitGroup,
  postRiverUnitGroup,
  deleteRiverUnitGroup,
} from 'api/pgads'

import { connect } from 'react-redux'
import R from 'ramda'
// import ErrorModal from 'core/component/ErrorModal'
// import UnitGroupEntry from './UnitGroupEntry'
// import EditPrompt from './EditPrompt'
// import { Overlay, DatePicker } from 'core'

import {
  getUtilityNameMap,
  getUnits,
  getUnitNameMap,
  getApiTargetInfo,
  getUnitTypeCode,
  getUnitGroups,
} from 'core/selectors'

import GenericEditScreen, {
  RowButtons,
  RowContainer,
} from 'core/component/GenericEditScreen'
import moment from 'moment'
import { DatePicker } from 'antd'
import { Filler } from '../../../core/screen-util'
import RiverUnitGroupModal from './RiverSystemModal'
import { DatePickerContext } from 'context'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
const GroupLabel = styled.div`
  font-weight: bold;
  font-size: 1.4em;
`
const CountLabel = styled.div`
  font-size: 1.2em;
  color: #777;
  margin-left: 1em;
`
const DateLabel = styled.div`
  font-size: 1em;
  color: #777;
  margin-left: 1em;
`

const RiverSystemUnit = props => {
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  // const { setError } = useContext(ErrorContext)

  const renderModal = ({ hideModal, modalInfo, list, ...rest }) => (
    <RiverUnitGroupModal
      hide={hideModal}
      data={modalInfo}
      availableUnits={props.availableUnits}
      unitNameMap={props.unitNameMap}
      utilityNameMap={props.utilityNameMap}
      list={list}
      {...props}
      {...rest}
    />
  )
  const renderRow = ({ item, popModal, style, onDelete }) => (
    <RowContainer style={style}>
      <GroupLabel>{item.river}</GroupLabel>
      <CountLabel>{item.units.length} units</CountLabel>
      <DateLabel>
        <b>Effective Date :</b>{' '}
        {moment(item.effectiveDate).format('MM/DD/YYYY')}
      </DateLabel>
      <Filler />
      <RowButtons
        item={{
          ...item,
          effectiveDate: moment(item.effectiveDate).format('YYYY-MM-DD'),
        }}
        onDelete={onDelete}
        popModal={popModal}
        duplicateClicked={() =>
          popModal({
            ...item,
            isNew: true,
            effectiveDate: moment(),
            isDuplicate: true,
          })
        }
      />
    </RowContainer>
  )

  const exportFunc = data => {
    const exData = (data || []).map(u =>
      (u.units || []).map(un => ({
        river: u.river,
        effectiveDate: u.effectiveDate,
        utility: un.substr(0, 3),
        utilityName: props.utilityNameMap[un.substr(0, 3)] || un.substr(0, 3),
        unit: un,
        unitName: props.unitNameMap[un] || un,
      }))
    )
    const flatData = R.flatten(exData)
    return R.sortWith([
      R.ascend(R.compose(R.toLower, R.prop('river'))),
      R.ascend(R.compose(R.toLower, R.prop('unitName'))),
      R.ascend(R.compose(R.toLower, R.prop('utilityName'))),
    ])(flatData)
  }

  const ExportHeader = [
    strCol({
      ident: 'river',
      display: 'Unit Group Name',
      width: 200,
    }),
    dateCol({
      ident: 'effectiveDate',
      display: 'Effective Date',
    }),
    strCol({
      ident: 'utilityName',
      display: 'Utility',
      width: 450,
      isRequired: true,
      sortOrder: 'asc',
      // dataFormatter: ({ value }) => props.utilityNameMap[value] || value,
    }),
    strCol({
      ident: 'unitName',
      display: 'Unit',
      width: 450,
      isKey: true,
      sortOrder: 'asc',
      // dataFormatter: ({ value }) => props.unitNameMap[value] || value,
    }),
  ]

  return (
    <GenericEditScreen
      // sortOnData={sortOnData}
      isExportAvaliable
      exportHeaders={ExportHeader}
      exportFunc={exportFunc}
      sort={data =>
        data.sort((d1, d2) =>
          d1 === undefined || d2 === undefined
            ? 1
            : d1.river.toLowerCase() <= d2.river.toLowerCase()
            ? -1
            : 1
        )
      }
      title="River System Unit"
      loadApiTask={getRiverUnitGroup}
      createApiTask={postRiverUnitGroup}
      updateApiTask={postRiverUnitGroup}
      deleteApiTask={deleteRiverUnitGroup}
      renderModal={renderModal}
      renderRow={renderRow}
      rowHeight={50}
      listHeightOffset={260}
      acceptFilter={item => filterText =>
        filterText == null ||
        (item.river || '').toLowerCase().includes(filterText.toLowerCase())}
      criteria={() => (
        <div style={{ marginLeft: '30px' }}>
          <label>Effective Date : </label>
          <DatePicker
            allowClear={false}
            format="MM/DD/YYYY"
            value={selectedDate}
            onChange={setSelectedDate}
          />
        </div>
      )}
      getLoadCriteria={() => selectedDate}
      dataMatcher={d1 => d2 =>
        d1.river === d2.river && d1.effectiveDate === d2.effectiveDate}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  availableUnits: getUnits(state),
  unitNameMap: getUnitNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
  unitTypeCode: getUnitTypeCode(state),
  unitGroups: getUnitGroups(state),
})

export default connect(mapStateToProps)(RiverSystemUnit)
